import Event from "../event"
import {toMomentDate} from "../../../gd/convert/moment-date"

export default function eventUpdateEndDate(event:Event, endDate:Moment|null) {
    event.endDate = toMomentDate(endDate)

    // if we set start date to null, end date should be null too
    if (endDate === null) {
        event.startDate = null
    }

    if (event.endDate && !event.startDate) {
        event.startDate = toMomentDate(event.endDate)
    }

    // if endDate BEFORE start set start = end because we update START here
    if (event.endDate && event.startDate && event.endDate.isBefore(event.startDate,'days')) {
        event.startDate = toMomentDate(event.endDate)
    }
}